import React from 'react'
import { css } from '@emotion/core'
import * as IPopup from './popup-type'
import { RoomType } from '@/models/room-manager/response/guest-room-indicator'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import { ReservationNoteCategory } from '@/models/reservation/reservation-note'
import { CategoryLabel } from '@/components/atoms/reservation-note/category-label'
import { CustomerTag } from '@/components/atoms/customer/customer-tag'
import { GuestRoomPaxLabel } from '@/components/molecules/room-manager/guest-room-pax-label'
import { ChangeReservationApprovedStatus } from '../../cleaning-manager/change-reservation-approved-status'
import { ApprovedStatusType } from '@/models/reservation-approved-status'

export class CheckInPopup extends React.Component<{}, {}> implements IPopup.PopupType {
  height = 185
  width = 200
  private unpaidTextHeight = 28
  private popupRef: React.RefObject<HTMLDivElement> = React.createRef()

  constructor(room: RoomType) {
    super(room)
    this.height -= room.nextReservation?.hasUnpaidSales ? 0 : this.unpaidTextHeight
  }

  getHeight(): number {
    if (this.popupRef.current) {
      return this.popupRef.current.clientHeight
    }
    return this.height
  }

  getWidth(): number {
    if (this.popupRef.current) {
      return this.popupRef.current.clientWidth
    }
    return this.width
  }

  Component: React.FC<IPopup.PopupProps> = ({ position, room, t }) => {
    return (
      <div ref={this.popupRef} css={[IPopup.popupStyle, css({ ...position })]}>
        <div css={headerStyle}>
          <p>{room.roomNumber}</p>
          <p>{t('Indicators.CIWaiting')}</p>
        </div>

        <div css={IPopup.bodyStyle}>
          <div className="info">
            {room.nextReservation?.guestNameKana && <p className="guest-name-kana">{room.nextReservation?.guestNameKana}</p>}
            <p className="guest-name">{room.nextReservation?.guestName}</p>
            {!!room.nextReservation?.customerTags?.length && (
              <div className="tag-block">
                {room.nextReservation?.customerTags.map(tag => (
                  <CustomerTag key={tag.name} fontColor={tag.fontColor} bgColor={tag.bgColor} name={tag.name} />
                ))}
              </div>
            )}

            <div className="horizon-divide"></div>

            <p className="stay-date">
              {dayjs(room.nextReservation?.checkInDate).format('M/D HH:mm')}&ensp;~&ensp;
              {dayjs(room.nextReservation?.checkOutDate).format('M/D HH:mm')}
            </p>
            {room.nextReservation && <GuestRoomPaxLabel pax={room.nextReservation.pax} />}

            {room.nextReservation && (
              <ChangeReservationApprovedStatus
                defaultStatus={room.nextReservation.roomAssignStatus}
                defaultRoom={room.nextReservation.guestRoomAssignIds}
                reservationId={room.nextReservation.reservationId}
                isDisabledEachSelection={room.nextReservation.roomAssignStatus === ApprovedStatusType.Reservation}
              />
            )}

            {room.nextReservation?.hasUnpaidSales && (
              <div className="paid-status">
                <img src={require('@/static/images/room/settle_orange.svg')} width={11} />
                <p>{t('Indicators.NotPaid')}</p>
              </div>
            )}
          </div>
          <div className="note">
            {Object.entries(ReservationNoteCategory).map(([_, value]) => (
              <div key={value}>
                <p className="category">
                  <CategoryLabel category={value} />
                </p>
                <p className="memo">{room?.nextReservation?.notes.find(note => note.category === value)?.memo ?? '-'}</p>
              </div>
            ))}
          </div>
        </div>

        <div css={IPopup.footerStyle}>
          {room.nextReservation ? (
            <>
              <Link
                to={{
                  pathname: room.nextReservation.checkInId
                    ? `/checkin/${room.nextReservation.checkInId}`
                    : `/reservation/${room.nextReservation.reservationId}`,
                  search: `?reservationId=${room.nextReservation.reservationId}`,
                }}
              >
                {t('Indicators.ReservationDetails')}
              </Link>
              <Link
                to={{
                  pathname: '/room-manager/daily',
                  search: `?reservationId=${room.nextReservation.reservationId}`,
                }}
              >
                {t('Indicators.RoomChange')}
              </Link>
            </>
          ) : (
            <>
              <p className="-disabled"> {t('Indicators.ReservationDetails')}</p>
              <p className="-disabled">{t('Indicators.RoomChange')}</p>
            </>
          )}
        </div>
      </div>
    )
  }
}

const headerStyle = css(IPopup.headerStyle, {
  background: '#FEF3F0',
  p: {
    color: '#F47110',
  },
})
